import { useEffect } from "react";

export function getChatIdFromUrl(): string | null {
  const match = window.location.pathname.match(/^\/chat\/(.+)$/);
  return match ? match[1] : null;
}

export function useChatUrlSync(handlers: {
  onSelect: (id: string) => void;
  onNew: () => void;
}) {
  const { onSelect, onNew } = handlers;
  useEffect(() => {
    const onPopState = () => {
      const id = getChatIdFromUrl();
      if (id) onSelect(id);
      else onNew();
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [onSelect, onNew]);
}

export function useEdgeSwipeToOpen(enabled: boolean, onOpen: () => void) {
  useEffect(() => {
    let startX = 0;
    let startY = 0;
    let tracking = false;
    const onTouchStart = (e: TouchEvent) => {
      if (!enabled) return;
      const t = e.touches[0];
      if (!t) return;
      if (t.clientX > 24) return;
      startX = t.clientX;
      startY = t.clientY;
      tracking = true;
    };
    const onTouchMove = (e: TouchEvent) => {
      if (!tracking) return;
      const t = e.touches[0];
      if (!t) return;
      const dx = t.clientX - startX;
      const dy = Math.abs(t.clientY - startY);
      if (dx > 60 && dy < 40) {
        tracking = false;
        onOpen();
      }
    };
    const onTouchEnd = () => { tracking = false; };
    window.addEventListener("touchstart", onTouchStart, { passive: true });
    window.addEventListener("touchmove", onTouchMove, { passive: true });
    window.addEventListener("touchend", onTouchEnd);
    return () => {
      window.removeEventListener("touchstart", onTouchStart);
      window.removeEventListener("touchmove", onTouchMove);
      window.removeEventListener("touchend", onTouchEnd);
    };
  }, [enabled, onOpen]);
}
